export const applyToAllPagesText = 'Применить ко всем листам';
